import React, { useRef, useEffect, useState } from "react";
import { useTheme } from "@mui/material";
import TooltipComponent from "../../../../components/CustomTooltip";

const ElipsisTypography = ({ children, width = '100%' }: any) => {
  const textRef = useRef<HTMLSpanElement>(null);
  const [isOverflowed, setIsOverflowed] = useState(false);
  const theme = useTheme();

  const checkOverflow = () => {
    const el = textRef.current;
    if (el) {
      setIsOverflowed(el.scrollWidth > el.clientWidth);
    }
  };

  useEffect(() => {
    const el = textRef.current;

    if (el) {
      checkOverflow(); // Initial check

      const resizeObserver = new ResizeObserver(() => {
        checkOverflow();
      });

      resizeObserver.observe(el);

      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [children, width]);

  const textStyle: React.CSSProperties = {
    display: '-webkit-box',
    WebkitLineClamp: 1, // only one line per field!
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    maxWidth: typeof width === 'number' ? `${width}px` : width,
    color: 'inherit',
    fontSize: 'inherit',
    lineHeight: '1.2',
    wordBreak: 'break-word',
    whiteSpace: 'nowrap',
    fontWeight: '600',
  };

  const content = (
    <span ref={textRef} style={textStyle}>
      {children}
    </span>
  );

  return isOverflowed ? (
    <TooltipComponent title={children} placement="right" theme={theme}>
      {content}
    </TooltipComponent>
  ) : (
    content
  );
};

export default ElipsisTypography;